var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7678 10.9822C14.7441 11.9585 14.7441 13.5415 13.7678 14.5178C12.7915 15.4941 11.2085 15.4941 10.2322 14.5178C9.25592 13.5415 9.25592 11.9585 10.2322 10.9822C11.2085 10.0059 12.7915 10.0059 13.7678 10.9822",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2538 4.98223C20.2302 5.95854 20.2302 7.54145 19.2538 8.51776C18.2775 9.49407 16.6946 9.49407 15.7183 8.51776C14.742 7.54145 14.742 5.95854 15.7183 4.98223C16.6946 4.00592 18.2775 4.00592 19.2538 4.98223",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.25C19.533 12.25 21 12.783 22 13.583",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2818 4.98223C9.25811 5.95854 9.25811 7.54145 8.2818 8.51776C7.30549 9.49407 5.72258 9.49407 4.74627 8.51776C3.76996 7.54145 3.76996 5.95854 4.74627 4.98223C5.72258 4.00592 7.30549 4.00592 8.2818 4.98223",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.583C3 12.783 4.467 12.25 6 12.25",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5911 19.75C15.4261 18.849 13.7521 18.25 12.0001 18.25C10.2481 18.25 8.57406 18.849 7.40906 19.75",
    stroke: "#4DACC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetings);
export default __webpack_public_path__ + "static/media/meetings.2dbfa458bbf9f35c6af2036cf3950432.svg";
export { ForwardRef as ReactComponent };